import React, { useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './LessonContentRenderer.module.css';

interface SuccessCelebrationProps {
    show: boolean;
    onComplete?: () => void;
}

const SuccessCelebration: React.FC<SuccessCelebrationProps> = ({ show, onComplete }) => {
    const [hasError, setHasError] = React.useState(false);

    // Auto-dismiss after 4 seconds as a fallback
    useEffect(() => {
        if (show && onComplete) {
            const timer = setTimeout(() => {
                onComplete();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [show, onComplete]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className={styles.celebrationOverlay}
                    onClick={onComplete} // Allow click to dismiss
                >
                    <div className={styles.celebrationContainer} onClick={(e) => e.stopPropagation()}>
                        {!hasError ? (
                            <DotLottieReact
                                src="/assets/animations/confetti-party.lottie"
                                autoplay
                                loop={false}
                                dotLottieRefCallback={(dotLottie) => {
                                    if (dotLottie) {
                                        dotLottie.addEventListener('complete', () => {
                                            if (onComplete) onComplete();
                                        });
                                        dotLottie.addEventListener('loadError', () => {
                                            setHasError(true);
                                        });
                                    }
                                }}
                                className={styles.celebrationLottie}
                            />
                        ) : (
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1.5 }}
                                className={styles.celebrationLottie}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '5rem' }}
                            >
                                ✨
                            </motion.div>
                        )}

                        <motion.div
                            initial={{ scale: 0.5, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ delay: 0.3, type: 'spring', stiffness: 200, damping: 10 }}
                            className={styles.celebrationText}
                        >
                            <span className={styles.celebrationEmoji}>✨</span>
                            <h3>Correct!</h3>
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};


export default SuccessCelebration;
